import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { post } from "helpers/api_helper";

export const getArchiveUserList = createAsyncThunk(
  "getArchiveUserList",
  async ({ data, callback }, Thunk) => {
    console.log(data, "data======chemist payload");
    try {
      let response = await post(`${URL.ARCHIVE_USER}`, data);
      console.log("response callback==>", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const removeArchiveUser = createAsyncThunk(
  "removeArchiveUser",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.REMOVE_ARCHIVE_USER, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);
